import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurybusonrentinmancharpune() {



  const cardData =
  {
    keyword: 'Luxury Bus on Rent in Manchar Pune',
    heading: 'Sanavi Travels: Luxury Bus on Rent in Manchar Pune',
    headingDescription: 'Luxury Bus on Rent in Manchar Pune provides premium and comfortable bus rental services for weddings, corporate events, tours, school trips, picnics, and outstation travel. With a fleet of well-maintained luxury AC buses and coaches ranging from 20 to 50 seaters, equipped with pushback seats, ample legroom, and modern amenities, we ensure a smooth and stylish travel experience. Offering professional drivers, flexible rental packages, transparent pricing, and 24/7 booking support, luxury bus rental services in Manchar Pune are ideal for safe, punctual, and hassle-free group transportation across Pune, Mumbai, Konkan, Shirdi, Mahabaleshwar, and beyond.',

    top: 'Top Places to Visit in Manchar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Manchar Town",
    "description": "Manchar is a prominent town in Ambegaon taluka of Pune district and serves as the commercial and administrative hub of the region. Located on the Pune–Nashik highway, Manchar is well-known as a gateway to Bhimashankar. The town reflects a vibrant blend of rural life, local trade, and cultural traditions, making it an important stop for pilgrims and travelers."
  },
  {
    "title": "Bhimashankar Jyotirlinga (Nearby)",
    "description": "Bhimashankar, one of the 12 sacred Jyotirlingas of Lord Shiva, is the most significant attraction near Manchar. Nestled in the dense forests of the Sahyadri ranges, the temple attracts millions of devotees every year. The journey from Manchar to Bhimashankar is scenic, passing through winding ghat roads, forests, and waterfalls."
  },
  {
    "title": "Manchar Market",
    "description": "Manchar hosts one of the busiest local markets in the Ambegaon region. The market is known for agricultural produce, vegetables, grains, livestock trading, and local goods. It offers visitors a true glimpse into rural Maharashtrian commerce and daily life."
  },
  {
    "title": "Bhima River Source Region",
    "description": "The surrounding region near Manchar is close to the origin of the Bhima River. The natural landscape includes forested hills, streams, and fertile land, making it environmentally and geographically significant."
  },
  {
    "title": "Local Temples and Shrines",
    "description": "Manchar and its nearby villages are home to several temples dedicated to Lord Shiva, Lord Ganesh, Goddess Durga, and village deities. These temples play a central role in local religious life and host festivals and rituals throughout the year."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat, located near Manchar, is a scenic mountain pass connecting the Deccan plateau to the Konkan region. Known for its steep roads, lush greenery, and panoramic valley views, it is especially popular during the monsoon season."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "During the monsoon, the hills around Manchar come alive with seasonal waterfalls and flowing streams. These natural sights enhance the beauty of the region and attract nature lovers and photographers."
  },
  {
    "title": "Agricultural Landscape",
    "description": "Manchar is surrounded by fertile farmland, with agriculture being the main livelihood. Sugarcane, vegetables, and grains dominate the fields, offering visitors a chance to observe traditional farming practices."
  },
  {
    "title": "Rural Culture and Festivals",
    "description": "Local festivals such as Ganesh Chaturthi, Mahashivratri, and village jatras are celebrated with enthusiasm in Manchar. These events showcase folk music, traditional attire, and the strong cultural roots of the region."
  },
  {
    "title": "Base for Trekking and Eco-Tourism",
    "description": "Manchar serves as a base point for trekkers and eco-tourists visiting Bhimashankar forests, nearby forts, and nature trails. Its location makes it ideal for exploring the natural and spiritual attractions of Ambegaon taluka."
  }
]
,



"services": [
{
"name": "Luxury Bus on Rent in Manchar Pune",
"description": "Luxury Bus on Rent in Manchar Pune provides premium and spacious buses for local and outstation travel, ideal for weddings, corporate trips, tourist excursions, and group outings. Equipped with modern amenities, comfortable seating, entertainment options, and professional drivers, these buses ensure a smooth, safe, and luxurious journey. Perfect for families, corporate clients, and tourists, it offers flexible scheduling, personalized itineraries, and exceptional service for trips in and around Manchar Pune."
},
{
"name": "Luxury Bus Hire Manchar",
"description": "Luxury Bus Hire Manchar offers customized and convenient rental services for weddings, corporate events, group tours, and long-distance travel. With high-end buses, skilled drivers, and tailored itineraries, it ensures a comfortable, safe, and stress-free travel experience. Ideal for families, tourists, and business travelers seeking premium transportation solutions from Manchar Pune to nearby destinations."
},
{
"name": "AC Luxury Bus Manchar",
"description": "AC Luxury Bus Manchar provides fully air-conditioned buses for a refreshing and comfortable travel experience. Perfect for long-distance journeys, family trips, corporate tours, and sightseeing excursions, these buses offer modern interiors, ample legroom, and professional drivers, ensuring passengers enjoy a relaxing and luxurious journey throughout Manchar Pune and surrounding areas."
},
{
"name": "Wedding Luxury Bus Manchar",
"description": "Wedding Luxury Bus Manchar specializes in providing elegant and spacious buses for weddings, family functions, and special events. With professional drivers, timely service, and premium vehicles, it ensures safe, smooth, and memorable travel for all wedding attendees traveling in and around Manchar Pune."
},
{
"name": "Corporate Luxury Bus Manchar",
"description": "Corporate Luxury Bus Manchar offers professional transportation solutions for business trips, employee transfers, corporate outings, and company events. Featuring modern buses, punctual service, and experienced drivers, it provides safe, efficient, and comfortable travel for organizations in and around Manchar Pune."
},
{
"name": "Outstation Luxury Bus Manchar",
"description": "Outstation Luxury Bus Manchar provides safe and comfortable buses for long-distance travel to tourist destinations, weekend getaways, and city tours. With spacious seating, professional drivers, and flexible itineraries, it ensures convenient and enjoyable journeys for families, groups, and corporate travelers traveling from Manchar Pune to nearby cities."
},
{
"name": "Affordable Luxury Bus Manchar",
"description": "Affordable Luxury Bus Manchar combines premium comfort with budget-friendly pricing. Ideal for families, groups, tourists, and corporate clients, it offers spacious seating, modern amenities, professional drivers, and reliable service, providing luxurious travel without compromising affordability from Manchar Pune to surrounding destinations."
},
{
"name": "Chauffeur Driven Luxury Bus",
"description": "Chauffeur Driven Luxury Bus provides professional drivers who manage navigation, traffic, and schedules, allowing passengers to enjoy a stress-free and comfortable journey. Suitable for weddings, corporate events, group trips, and tourist excursions, it ensures safe, smooth, and luxurious travel experiences in and around Manchar Pune."
},
{
"name": "Best Luxury Bus Service Manchar",
"description": "Best Luxury Bus Service Manchar guarantees high-quality, well-maintained buses, punctual service, and professional drivers. Catering to families, corporate groups, tourists, and event organizers, it provides reliable, comfortable, and safe transportation for weddings, sightseeing trips, and long-distance journeys from Manchar Pune."
},
{
"name": "Tourist Luxury Bus Manchar",
"description": "Tourist Luxury Bus Manchar caters to travelers exploring Manchar and nearby tourist attractions. With organized itineraries, spacious buses, modern amenities, and experienced drivers, it provides a hassle-free and memorable sightseeing experience for families, groups, and solo travelers."
},
{
"name": "Group Travel Luxury Bus",
"description": "Group Travel Luxury Bus specializes in providing spacious, comfortable, and well-equipped buses for families, friends, corporate teams, and social groups. With professional drivers, flexible itineraries, and reliable service, it ensures safe and enjoyable group travel experiences from Manchar Pune to surrounding areas."
},
{
"name": "Online Bus Booking Manchar",
"description": "Online Bus Booking Manchar allows passengers to reserve luxury buses quickly and conveniently with instant confirmation. Offering multiple bus options, transparent pricing, and flexible scheduling, it simplifies travel planning for families, tourists, corporate clients, and groups traveling from or to Manchar Pune."
},
{
"name": "Event Luxury Bus Manchar",
"description": "Event Luxury Bus Manchar provides dedicated buses for weddings, corporate events, parties, and other special occasions. With professional drivers, spacious vehicles, and reliable service, it ensures organized, safe, and luxurious transportation for all attendees in Manchar Pune and nearby areas."
},
{
"name": "Manchar Travel Bus",
"description": "Manchar Travel Bus offers complete bus rental solutions for sightseeing trips, corporate travel, weddings, and outstation journeys. Combining safety, comfort, luxury, affordability, and professional service, it caters to families, tourists, and corporate clients seeking dependable transportation from Manchar Pune to nearby destinations."
},
{
"name": "Pune Manchar Luxury Bus",
"description": "Pune Manchar Luxury Bus provides premium luxury buses for travel between Pune and Manchar. Featuring modern interiors, comfortable seating, air conditioning, and professional drivers, it ensures safe, timely, and relaxing travel for families, corporate clients, tourists, and groups making the journey between Pune and Manchar."
}
],
"tableData": [
["Luxury Bus on Rent in Manchar Pune", "Luxury Bus Hire Manchar"],
["AC Luxury Bus Manchar", "Wedding Luxury Bus Manchar"],
["Corporate Luxury Bus Manchar", "Outstation Luxury Bus Manchar"],
["Affordable Luxury Bus Manchar", "Chauffeur Driven Luxury Bus"],
["Best Luxury Bus Service Manchar", "Tourist Luxury Bus Manchar"],
["Group Travel Luxury Bus", "Online Bus Booking Manchar"],
["Event Luxury Bus Manchar", "Manchar Travel Bus"],
["Pune Manchar Luxury Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Luxury Bus on Rent in Manchar Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium luxury bus rental services in Manchar Pune, ideal for group travel, family trips, corporate events, and special occasions with superior comfort and style."
  },
  {
    "WhyChooseheading": "Spacious and High‑End Coaches",
    "WhyChoosedescription": "Our luxury buses are equipped with plush seating, air‑conditioning, ample legroom, and modern amenities to ensure a comfortable and enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed, courteous, and trained drivers are familiar with Manchar Pune routes and ensure safe, smooth, and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for luxury bus rentals in Manchar Pune, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel queries, and itinerary planning for your luxury bus service."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or custom luxury bus hire packages to match your schedule and travel preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every luxury bus is thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for luxury bus rentals in Manchar Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide luxury bus rental services in Manchar Pune?',
    answer: 'Yes, Sanavi Travels offers premium luxury bus rental services in Manchar Pune for various travel needs.'
  },
  {
    question: 'How can I book a luxury bus in Manchar Pune?',
    answer: 'You can easily book a luxury bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of luxury buses are available for rent in Manchar Pune?',
    answer: 'Sanavi Travels offers a range of luxury buses with comfortable seating, air‑conditioning, and premium features to suit your group size and comfort needs.'
  },
  {
    question: 'Are the drivers experienced with routes in Manchar Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes around Manchar Pune to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Manchar Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Manchar Pune and surrounding areas.'
  },
  {
    question: 'Is the luxury bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock luxury bus rental services in Manchar Pune to suit your travel schedule.'
  },
  {
    question: 'Are the luxury buses sanitized before every trip?',
    answer: 'Yes, all luxury buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for luxury bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for luxury bus bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your luxury bus trip in Manchar Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Booked a luxury bus in Manchar Pune with Sanavi Travels — incredibly comfortable seats, excellent service, and on‑time pickups!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Richa Patil',
    feedback: 'Sanavi Travels provided a premium luxury bus experience in Manchar Pune — perfect for our group travel. Highly recommended!',
    rating: 5
  }
];





























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusOrCoach",
  "name": "Luxury Bus on Rent in Manchar Pune - Sanavi Travels",
  "description": "Sanavi Travels offers luxury bus rentals in Manchar Pune. AC, wedding, corporate, outstation, and tourist luxury buses available. Chauffeur-driven, affordable, and online booking enabled.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};






  return (
    <div>


<Helmet>
  <title>
    Luxury Bus on Rent in Manchar Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC, wedding, corporate, outstation, and tourist luxury buses in Manchar Pune with Sanavi Travels. Affordable, chauffeur-driven, and online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/151.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurybusonrentinmancharpune;